import React from 'react';
import { Wrapper } from './CategoryTree.styles';
import {
	ApLoaderDefault,
	ApLoaderText,
} from '@alixpartners/ui-components';
import ListTree from './ListTree/ListTree';
import { CHART_COLORS } from 'styles/colors';

const CategoryTree = props => {
	const {
		isCategoryFetching,
		categoryTreeData,
		onChangeSelectionAll,
		onChangeCategorySelection,
	} = props;
	return (
		<Wrapper>
			{isCategoryFetching ? (
				<ApLoaderDefault loaderText={() => <ApLoaderText />} />
			) : (
				<>
					{categoryTreeData.length > 0 ? (
						<>
							{categoryTreeData.map((data, index) => (
								<ListTree
									{...data}
									key={index}
									colors={CHART_COLORS}
									onChangeSelectionAll={onChangeSelectionAll}
									onChangeCategorySelection={onChangeCategorySelection}
								/>
							))}
						</>
					) : (
						<p style={{textAlign: 'center'}}>No data available.</p>
					)}
				</>
			)}
		</Wrapper>
	);
};

export default CategoryTree;
